import { useEffect, useState } from "react";
import unsplash from "../api/unsplash";
import { consulenzaAuth } from "./useConsulenzaData";
export default function useExtraAccess() {
  const [access, setAccess] = useState(null);
  useEffect(() => {
    let active = true;
    unsplash
      .get("extraClienti/accesso", consulenzaAuth())
      .then((r) => {
        if (active) setAccess(r.data.data);
      })
      .catch(() => {
        if (active) setAccess({ aree: {}, canFatturazione: false });
      });
    return () => {
      active = false;
    };
  }, []);
  return access;
}
